export default {
  'logo.name': 'BasetaoSheet',
  'logo.tagline': 'Centro de recursos',

  'meta.title': 'Planilha Basetao: produtos, vendedores e guias de compra',
  'meta.description': 'Explore recursos da planilha Basetao, achados de produtos, guias de vendedores, dicas de QC, informações de envio e guias de compra.',

  'nav.spreadsheet': 'Planilha',
  'nav.home': 'Início',
  'nav.guide': 'Guia de compra',
  'nav.guides': 'Guias',
  'nav.products': 'Produtos',
  'nav.sellers': 'Vendedores',
  'nav.qc': 'Controle de qualidade',
  'nav.shipping': 'Envio',
  'nav.reviews': 'Avaliações',
  'nav.safety': 'Segurança',
  'nav.cta': 'Explorar a planilha',

  'hero.eyebrow': 'O CENTRO DE RECURSOS DA PLANILHA BASETAO',
  'hero.title': 'Planilha Basetao — Encontre produtos, vendedores e guias de compra mais rápido',
  'hero.subtitle': 'Explore recursos organizados da planilha Basetao, achados de produtos, informações de vendedores, guias de controle de qualidade, dicas de envio e tutoriais práticos — tudo em um só lugar.',
  'hero.ctaPrimary': 'Planilha Basetao',
  'hero.ctaSecondary': 'Comprar agora',
  'hero.dropdownLabel': 'Explorar uma categoria',
  'hero.dropdownPlaceholder': 'Escolha uma categoria de produto…',
  'hero.trust': 'Recurso independente · Guias atualizados · Pesquisa de produtos e vendedores · Controle de qualidade e envio',

  'value.title': 'Tudo o que você precisa para navegar no Basetao',
  'value.subtitle': 'Um ponto de partida claro e organizado para descobrir produtos de forma mais inteligente.',
  'value.c1.title': 'Planilha Basetao',
  'value.c1.desc': 'Descubra recursos organizados e aprenda a avaliar informações de produtos e vendedores.',
  'value.c2.title': 'Guias de produtos e vendedores',
  'value.c2.desc': 'Compare produtos, vendedores, preços e os sinais importantes antes de pedir.',
  'value.c3.title': 'Controle de qualidade',
  'value.c3.desc': 'Entenda as fotos de QC, os indicadores de qualidade e o que verificar antes de pedir.',
  'value.c4.title': 'Envio e segurança',
  'value.c4.desc': 'Compare opções e custos de envio e aprenda a identificar riscos e anúncios suspeitos.',

  'categories.title': 'Explorar categorias de produtos',
  'categories.subtitle': 'Vá direto a uma categoria na loja principal e comece a explorar achados organizados.',
  'categories.open': 'Abrir categoria',

  'about.eyebrow': 'O QUE É UMA PLANILHA BASETAO?',
  'about.title': 'Uma forma mais inteligente de encontrar produtos e vendedores',
  'about.body1': 'Uma planilha Basetao é um documento compartilhado e organizado que reúne links de produtos, detalhes de vendedores, preços e notas do ecossistema do agente de compras Basetao. Em vez de rolar por listagens infinitas, os compradores usam essas planilhas para comparar opções lado a lado e entender exatamente o que estão comprando.',
  'about.body2': 'A maioria das planilhas é organizada por categoria — tênis, moletons, camisetas, jaquetas, bolsas e mais — e cada linha geralmente aponta para um produto ou vendedor com contexto extra, como preço, notas de tamanho e observações de QC.',
  'about.body3': 'Como esses documentos são atualizados com frequência, eles são um atalho prático para descobrir novos itens e vendedores confiáveis sem passar horas vasculhando marketplaces.',
  'about.list1': 'Links de produtos selecionados',
  'about.list2': 'Sinais de vendedores e preços',
  'about.list3': 'Atualizações regulares',

  'how.title': 'Como usar uma planilha Basetao',
  'how.subtitle': 'Quatro passos simples para tirar valor real de qualquer planilha.',
  'how.s1.title': 'Descobrir',
  'how.s1.desc': 'Encontre produtos e categorias relevantes que correspondam ao que você procura.',
  'how.s2.title': 'Comparar',
  'how.s2.desc': 'Revise as informações de produto, vendedor e preço lado a lado.',
  'how.s3.title': 'Verificar',
  'how.s3.desc': 'Confira links, sinais de vendedores e informações de QC disponíveis.',
  'how.s4.title': 'Decidir',
  'how.s4.desc': 'Use as informações para tomar sua própria decisão informada.',

  'topics.title': 'Recursos populares do Basetao',
  'topics.subtitle': 'Guias e recursos para comprar com mais confiança.',
  'topics.cardTitle': 'Guia da planilha Basetao',
  'topics.cardDesc': 'Aprenda o que é uma planilha Basetao, como lê-la e usá-la para encontrar melhores produtos e vendedores.',
  'topics.readMore': 'Ler o guia',
  'topics.moreComing': 'Mais guias em breve',
  'guide.notFound': 'Este guia não foi encontrado.',

  'faq.title': 'Perguntas frequentes sobre a planilha Basetao',
  'faq.q1': 'O que é uma planilha Basetao?',
  'faq.a1': 'É um documento organizado que reúne links de produtos, informações de vendedores, preços e notas do ecossistema Basetao para comparar e descobrir com mais facilidade.',
  'faq.q2': 'A planilha é gratuita?',
  'faq.a2': 'Os recursos da planilha são informativos. Sempre verifique a fonte e os links antes de comprar.',
  'faq.q3': 'Com que frequência a planilha é atualizada?',
  'faq.a3': 'Depende da fonte. Planilhas confiáveis tendem a ser atualizadas regularmente conforme novos produtos e vendedores são adicionados.',
  'faq.q4': 'Posso confiar em todos os vendedores listados?',
  'faq.a4': 'Nenhum recurso pode garantir um vendedor. Use vários sinais — avaliações, fotos de QC e informações de envio — antes de decidir.',
  'faq.q5': 'Quais categorias costumam ser incluídas?',
  'faq.a5': 'Categorias comuns incluem tênis, moletons, camisetas, jaquetas, calças, bonés, conjuntos, roupas íntimas, camisas esportivas, acessórios, bolsas, cintos, perfumes e mais.',

  'cta.title': 'Pronto para explorar os recursos da planilha Basetao?',
  'cta.subtitle': 'Navegue pelos guias mais recentes, recursos de produtos e informações de compra em um hub organizado.',
  'cta.button': 'Explorar a planilha Basetao',

  'footer.tagline': 'Um centro de recursos independente para guias da planilha Basetao, achados de produtos e informações de compra.',
  'footer.disclaimer': 'Este site é um recurso informativo independente. Não é afiliado nem endossado pelo Basetao.',
  'footer.navTitle': 'Explorar',
  'footer.resourceTitle': 'Recursos',
  'footer.copyright': 'Todos os direitos reservados.',

  'cat.shoes': 'Tênis',
  'cat.hoodies': 'Moletons / Suéteres',
  'cat.tshirts': 'Camisetas',
  'cat.jackets': 'Jaquetas',
  'cat.pants': 'Calças / Shorts',
  'cat.headwear': 'Bonés',
  'cat.sets': 'Conjuntos',
  'cat.underwear': 'Roupas íntimas',
  'cat.jersey': 'Camisas esportivas',
  'cat.accessories': 'Acessórios',
  'cat.bags': 'Bolsas',
  'cat.belts': 'Cintos',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Outros itens',
};